export const PromotionHubQuickFilter = {
    ForYou: 'ForYou',
    NonStop: 'NonStop',
} as const;
export type PromotionHubQuickFilter = typeof PromotionHubQuickFilter[keyof typeof PromotionHubQuickFilter];

const PromotionHubQuickFilterTranslationKeys: Record<PromotionHubQuickFilter, string> = {
    ForYou: 'promotion_hub.filter.for_you',
    NonStop: 'promotion_hub.filter.non_stop',
};

export function getQuickFilterTranslationKey(quickFilter: PromotionHubQuickFilter): string {
    return PromotionHubQuickFilterTranslationKeys[quickFilter];
}
